import { render, staticRenderFns } from "./MessageThrowEventDataInputs.vue?vue&type=template&id=6b9b252c&scoped=true&"
import script from "./MessageThrowEventDataInputs.vue?vue&type=script&lang=js&"
export * from "./MessageThrowEventDataInputs.vue?vue&type=script&lang=js&"
import style0 from "./MessageThrowEventDataInputs.vue?vue&type=style&index=0&id=6b9b252c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b9b252c",
  null
  
)

export default component.exports